import { TableHead, TableRow, TableCell, Typography, Tooltip } from '@mui/material'
import type { FC } from 'react'

const TableHeader: FC = () => (
  <TableHead>
    <TableRow>
      <TableCell>
        <Typography variant="subtitle2">Name</Typography>
      </TableCell>
      <TableCell width={170}>
        <Typography variant="subtitle2">Escalations</Typography>
      </TableCell>
      <TableCell width={170}>
        <Typography variant="subtitle2">Inventory</Typography>
      </TableCell>
      <TableCell width={170}>
        <Typography variant="subtitle2">Added today</Typography>
      </TableCell>
      <TableCell width={170}>
        <Typography variant="subtitle2">Completed today</Typography>
      </TableCell>
      <TableCell width={170}>
        <Tooltip title="Missed SLA last working day" placement="top">
          <Typography variant="subtitle2">Missed SLA 1...</Typography>
        </Tooltip>
      </TableCell>
      <TableCell width={170}>
        <Tooltip title="Missed SLA two days in a row" placement="top">
          <Typography variant="subtitle2">Missed SLA 2...</Typography>
        </Tooltip>
      </TableCell>
      <TableCell width={110} />
    </TableRow>
  </TableHead>
)

export default TableHeader
